.migas {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--s-4);
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  color: var(--text-muted);
}
.enlace {
  color: var(--text-muted);
  text-decoration: none;
  border-radius: var(--r-xs);
  transition: color var(--dur-fast) var(--ease-standard);
}
@media (hover: hover) {
  .enlace:hover {
    color: var(--text-strong);
  }
}
.enlace:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
.actual {
  color: var(--text-strong);
  font-weight: var(--fw-semibold);
}
.separador {
  display: inline-flex;
  color: var(--text-subtle);
}
@media (prefers-reduced-motion: reduce) {
  .enlace {
    transition: none;
  }
}
